import { render, staticRenderFns } from "./FormGroup.vue?vue&type=template&id=18882fb1&scoped=true&"
import script from "./FormGroup.vue?vue&type=script&lang=js&"
export * from "./FormGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18882fb1",
  null
  
)

export default component.exports